import { apiGet } from '../common/apiTools';
import { getServiceBaseURL } from '../common/getServiceBaseURL';
import { APIServiceEnum } from '../enums/APIServiceEnum';
import { ICheckNotification } from '../interfaces/ICheckNotification';

export async function checkNotification(): Promise<ICheckNotification> {
  return apiGet<ICheckNotification>(`${getServiceBaseURL(APIServiceEnum.KNM_SERVICE)}/knm-plan/check-notification`);
}
